module.exports = __webpack_public_path__ + "img/5f70e86.png";